import {
  AUTHORISED_DISTRIBUTORS,
  PARALLEL_IMPORTERS,
} from '@/constants/global';

import type { DealerType } from './types';

export const dealerTypeConfig: {
  text: string;
  value: DealerType;
}[] = [
  {
    text: '(Parallel Importer)',
    value: PARALLEL_IMPORTERS,
  },
  {
    text: '(Authorised Distributor)',
    value: AUTHORISED_DISTRIBUTORS,
  },
];
